// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styling */
.bulk-collection-v1-container {
    padding: 20px;
    width: 100%;
    margin: 0 auto;
    min-height: 100vh;
    background-color: #f9f9f9;
    position: relative;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .bulk-collection-content {
    width: 100%;
    max-width: 1400px; /* Set a max-width for large screens */
    margin: 0 auto;
  }
  
  .bulk-collection-header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .back-button {
    display: flex;
    align-items: center;
    background: #f3f3f3;
    border: none;
    border-radius: 4px;
    padding: 8px 15px;
    margin-right: 20px;
    cursor: pointer;
    transition: background 0.2s;
    color: #333;
    font-weight: 500;
  }
  
  .back-button:hover {
    background: #e6e6e6;
  }
  
  .back-button svg {
    margin-right: 8px;
  }
  
  .bulk-collection-header h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #333;
    flex-grow: 1;
  }
  
  /* Dairy Info Section */
  .dairy-info-container {
    width: 100%;
    max-width: 1400px;
    background-color: #fff;
    border-radius: 5px;
    padding: 15px 20px;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  .dairy-info-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
  }
  
  .dairy-details, .owner-details {
    flex: 1 1;
    min-width: 250px;
  }
  
  .info-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .info-icon {
    font-size: 1.2em;
    color: #007bff;
    margin-right: 10px;
    width: 20px;
  }
  
  .info-label {
    font-weight: 600;
    color: #555;
    margin-right: 10px;
    min-width: 80px;
  }
  
  .info-value {
    color: #333;
    font-weight: 500;
  }
  
  .info-loading {
    color: #6c757d;
    text-align: center;
    padding: 10px;
    font-style: italic;
  }
  
  /* Loading state */
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  
  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #007bff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  /* Messages */
  .success-message,
  .error-message {
    display: flex;
    align-items: center;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
    animation: fadeIn 0.3s ease-in-out;
  }
  
  .success-message {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }
  
  .error-message {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    justify-content: space-between;
  }
  
  .success-message svg,
  .error-message svg {
    margin-right: 10px;
    font-size: 1.2em;
  }
  
  .close-error {
    background: none;
    border: none;
    color: #721c24;
    cursor: pointer;
    padding: 5px;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* Current Rate */
  .current-rate-info {
    background-color: #fff;
    border-radius: 5px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 1400px; /* Match the content max-width */
  }
  
  /* Global Settings */
  .global-settings {
    background-color: #fff;
    border-radius: 5px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 1400px;
  }
  
  .global-settings-row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: center;
  }
  
  .global-setting {
    flex: 1 1;
    min-width: 200px;
  }
  
  .global-setting label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #343a40;
  }
  
  .global-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
  }
  
  .global-input:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  
  /* Rate display styles */
  .rate-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .rate-display p {
    margin: 0;
    font-weight: 500;
    color: #333;
  }
  
  /* Rate Type Section */
  .rate-type-section {
    background-color: #fff;
    border-radius: 5px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 1400px;
  }
  
  .rate-type-display {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .rate-type-display p {
    margin: 0;
    font-weight: 500;
    color: #333;
  }
  
  .rate-type-edit {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .rate-type-edit label {
    margin: 0;
    font-weight: 500;
    color: #333;
  }
  
  .rate-type-select {
    padding: 8px 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 12px;
    padding-right: 30px;
  }
  
  .edit-rate-button {
    display: flex;
    align-items: center;
    background: #f3f3f3;
    border: none;
    border-radius: 4px;
    padding: 8px 15px;
    cursor: pointer;
    transition: background 0.2s;
    color: #0066cc;
    font-weight: 500;
  }
  
  .edit-rate-button:hover {
    background: #e6e6e6;
  }
  
  .edit-rate-button svg {
    margin-right: 8px;
  }
  
  /* Rate Edit Form */
  .rate-edit {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .rate-edit label {
    margin: 0;
    font-weight: 500;
    color: #333;
  }
  
  .rate-input {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-right: 10px;
    width: 120px;
  }
  
  .save-rate-button {
    display: flex;
    align-items: center;
    background: #28a745;
    border: none;
    border-radius: 4px;
    padding: 8px 15px;
    cursor: pointer;
    transition: background 0.2s;
    color: white;
    font-weight: 500;
  }
  
  .save-rate-button:hover {
    background: #218838;
  }
  
  .save-rate-button svg {
    margin-right: 8px;
  }
  
  .save-rate-button:disabled {
    background: #6c757d;
    cursor: not-allowed;
  }
  
  /* CSV/Excel Grid Layout */
  .csv-grid-container {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    width: 100%;
    overflow-x: auto;
    max-width: 100%;
    margin: 0 auto; /* Center the container */
  }
  
  .excel-toolbar {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
  }
  
  .toolbar-left {
    display: flex;
    gap: 8px;
  }
  
  .add-row-button,
  .preview-button {
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    font-weight: 500;
    display: flex;
    align-items: center;
    transition: all 0.2s;
    cursor: pointer;
    white-space: nowrap;
  }
  
  .add-row-button {
    background-color: #28a745;
    color: white;
  }
  
  .add-row-button:hover {
    background-color: #218838;
  }
  
  .preview-button {
    background-color: #007bff;
    color: white;
  }
  
  .preview-button:hover {
    background-color: #0069d9;
  }
  
  .add-row-button svg,
  .preview-button svg {
    margin-right: 8px;
  }
  
  .preview-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }
  
  /* Excel Table Styling */
  .excel-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 1200px; /* Ensure minimum width to fit all columns */
  }
  
  .excel-table th,
  .excel-table td {
    border: 1px solid #dee2e6;
    padding: 0;
    position: relative;
    height: 34px;
    overflow: visible;
    font-size: 13px;
  }
  
  .excel-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    text-align: center;
    padding: 8px 4px;
    position: sticky;
    top: 0;
    z-index: 10;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .excel-table tbody {
    max-height: 400px;
    overflow-y: auto;
  }
  
  .excel-table .data-row:hover {
    background-color: #f5f9fc;
  }
  
  .excel-table .data-row:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .excel-table .data-row:nth-child(even):hover {
    background-color: #f0f5fa;
  }
  
  .excel-table td.has-error {
    background-color: rgba(255, 0, 0, 0.05);
  }
  
  .excel-cell-input,
  .excel-cell-select {
    width: 100%;
    height: 100%;
    padding: 0 6px;
    border: none;
    background: transparent;
    font-size: 14px;
  }
  
  /* Style for disabled inputs to make them appear faded */
  .excel-cell-input:disabled,
  .excel-cell-select:disabled {
    background-color: #f5f5f5;
    color: #9e9e9e;
    cursor: not-allowed;
    opacity: 0.7;
    border-left: 2px solid #e0e0e0;
  }
  
  .excel-cell-input:focus,
  .excel-cell-select:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px #4d90fe;
  }
  
  .excel-cell-select {
    appearance: none;
    -webkit-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 6px center;
    background-size: 12px;
    padding-right: 24px;
  }
  
  .calculated-cell {
    position: relative;
  }
  
  .calc-indicator {
    position: absolute;
    top: 0;
    right: 2px;
    color: #0066cc;
    font-size: 12px;
    font-weight: bold;
  }
  
  .calc-indicator.auto {
    color: #28a745;
    background-color: rgba(40, 167, 69, 0.1);
    padding: 0 4px;
    border-radius: 2px;
    right: 4px;
    top: 2px;
    font-size: 10px;
  }
  
  /* Special styling for calculated fields based on rate type */
  .calculated-cell .excel-cell-input:disabled {
    background-color: #f0f8ff; /* Light blue background */
    color: #006699;
    border-left: 2px solid #4dabf7;
    opacity: 0.8;
  }
  
  /* Auto-calculated field style */
  .excel-cell-input.auto-calculated {
    background-color: #f0f8ff;
    font-style: italic;
  }
  
  /* Disabled field container */
  .disabled-field {
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  /* Disabled input style */
  .excel-cell-input.disabled-input {
    background-color: #f6f6f6;
    color: #b0b0b0;
    text-decoration: line-through;
    opacity: 0.6;
  }
  
  /* Indicator for disabled fields */
  .disabled-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 10px;
    color: #999;
    background-color: rgba(0, 0, 0, 0.05);
    padding: 1px 4px;
    border-radius: 2px;
    pointer-events: none; /* Prevent it from blocking interactions */
    white-space: nowrap;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0.8;
  }
  
  .calc-info {
    margin-top: -15px;
    margin-bottom: 15px;
    color: #0066cc;
    font-size: 13px;
    font-style: italic;
  }
  
  .cell-error {
    position: absolute;
    bottom: -18px;
    left: 0;
    width: 100%;
    background-color: #f8d7da;
    color: #721c24;
    font-size: 12px;
    padding: 2px 4px;
    text-align: center;
    z-index: 20;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .cell-warning {
    position: absolute;
    bottom: -18px;
    left: 0;
    width: 100%;
    background-color: #fff3cd;
    color: #856404;
    font-size: 12px;
    padding: 2px 4px;
    text-align: center;
    z-index: 20;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .empty-message {
    text-align: center;
    padding: 20px;
    color: #6c757d;
    font-style: italic;
  }
  
  .delete-row-btn {
    background: none;
    border: none;
    color: #dc3545;
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .delete-row-btn:hover {
    background-color: rgba(220, 53, 69, 0.1);
  }
  
  /* Customer search cell and dropdown styling */
  .customer-search-cell {
    position: relative;
    width: 100%;
  }
  
  .excel-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }
  
  .dropdown-item {
    padding: 8px 12px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    transition: background-color 0.2s;
  }
  
  .dropdown-item:hover {
    background-color: #f8f9fa;
    cursor: pointer;
  }
  
  .dropdown-item.selected {
    background-color: #e9ecef;
    font-weight: bold;
  }
  
  .dropdown-item.add-new {
    color: #007bff;
    font-weight: 500;
    background-color: #f8f9fa;
    border-top: 1px solid #ddd;
  }
  
  .no-results {
    padding: 8px 12px;
    color: #888;
    font-style: italic;
    text-align: center;
  }
  
  /* Make sure the dropdown appears above other elements */
  .excel-table .data-row td {
    position: relative;
  }
  
  /* Highlight active search cell */
  .excel-cell-input:focus {
    outline: 2px solid #1a73e8;
    border-color: #1a73e8;
  }
  
  /* Enhance the visibility of customer cell */
  .excel-table td:first-child .excel-cell-input {
    width: 100%;
    min-width: 150px;
  }
  
  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    overflow-y: auto;
    padding: 20px;
    backdrop-filter: blur(3px);
  }
  
  .preview-modal,
  .new-customer-modal {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    animation: modalFadeIn 0.3s ease-in-out;
    overflow: hidden;
  }
  
  .new-customer-modal {
    max-width: 550px; /* Slightly wider */
    margin: 20px;
  }
  
  .preview-modal {
    max-width: 1100px; /* Increased from 900px */
    margin: 20px;
  }
  
  /* Specific padding adjustments for the new customer modal */
  .new-customer-modal .modal-header {
    padding: 22px 28px;
  }
  
  .new-customer-modal .modal-body {
    padding: 28px 32px;
  }
  
  .new-customer-modal .modal-footer {
    padding: 20px 28px;
  }
  
  .new-customer-modal .modal-footer button {
    padding: 12px 20px;
    min-width: 100px;
  }
  
  /* Specific styling for the preview modal */
  .preview-modal .modal-header {
    padding: 22px 28px;
  }
  
  .preview-modal .modal-body {
    padding: 24px 28px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    gap: 0; /* Remove default gap to ensure proper spacing */
  }
  
  .preview-modal .modal-footer {
    padding: 20px 28px;
  }
  
  .preview-modal .modal-footer button {
    padding: 12px 20px;
    min-width: 100px;
  }
  
  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 24px;
    border-bottom: 1px solid #e8eaed;
    background-color: #f8f9fa;
  }
  
  .modal-header h2 {
    margin: 0;
    font-size: 20px;
    color: #3c4043;
    font-weight: 600;
  }
  
  .close-modal-button {
    background: none;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #5f6368;
    transition: all 0.2s;
  }
  
  .close-modal-button:hover {
    background-color: rgba(95, 99, 104, 0.1);
    color: #202124;
  }
  
  .modal-body {
    padding: 24px;
    overflow-y: auto;
    flex-grow: 1;
  }
  
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid #e8eaed;
    background-color: #f8f9fa;
  }
  
  .modal-footer button {
    margin-left: 12px;
    padding: 10px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    display: flex;
    align-items: center;
    transition: all 0.2s;
    font-size: 14px;
  }
  
  .cancel-button {
    background: #f8f9fa;
    color: #3c4043;
    border: 1px solid #dadce0;
  }
  
  .cancel-button:hover {
    background: #f1f3f4;
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);
  }
  
  .confirm-button,
  .save-button {
    background: #1a73e8;
    color: white;
  }
  
  .confirm-button:hover,
  .save-button:hover {
    background: #1765cc;
    box-shadow: 0 1px 3px rgba(26, 115, 232, 0.4);
  }
  
  .confirm-button:disabled,
  .save-button:disabled {
    background: #c2c7c7;
    cursor: not-allowed;
    box-shadow: none;
  }
  
  .confirm-button svg,
  .save-button svg {
    margin-right: 8px;
  }
  
  /* New customer form */
  .form-instructions {
    margin-bottom: 24px;
    color: #5f6368;
    font-size: 14px;
    grid-column: span 2;
  }
  
  .form-group {
    margin-bottom: 24px;
    position: relative;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 10px;
    font-weight: 500;
    color: #3c4043;
    font-size: 14px;
  }
  
  .form-group input,
  .form-group textarea {
    width: 100%;
    padding: 14px 16px;
    border: 1px solid #dadce0;
    border-radius: 4px;
    font-size: 14px;
    color: #202124;
    transition: all 0.2s;
    background-color: #fff;
  }
  
  .form-group input:focus,
  .form-group textarea:focus {
    border-color: #1a73e8;
    outline: none;
    box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
  }
  
  .form-group input::placeholder,
  .form-group textarea::placeholder {
    color: #80868b;
  }
  
  .form-group input:hover,
  .form-group textarea:hover {
    border-color: #bdc1c6;
  }
  
  /* Required field indicator */
  .form-group label[for="customer-name"]::after {
    content: " *";
    color: #d93025;
  }
  
  /* Organize form in columns for larger screens */
  @media (min-width: 576px) {
    .modal-body {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }
    
    .new-customer-modal .modal-body {
      gap: 24px;
    }
    
    .form-group:last-child {
      grid-column: span 2;
      margin-top: 8px;
    }
  }
  
  /* Column widths in the Excel table */
  .excel-table th:nth-child(1), /* Serial Number */
  .excel-table td:nth-child(1) {
    width: 50px;
    min-width: 50px;
    text-align: center;
  }
  
  .excel-table th:nth-child(2), /* Date */
  .excel-table td:nth-child(2) {
    width: 120px;
    min-width: 120px;
  }
  
  .excel-table th:nth-child(3), /* Time */
  .excel-table td:nth-child(3) {
    width: 90px;
    min-width: 90px;
  }
  
  .excel-table th:nth-child(4), /* Customer */
  .excel-table td:nth-child(4) {
    width: 180px;
    min-width: 180px;
  }
  
  .excel-table th:nth-child(5), /* Weight */
  .excel-table th:nth-child(6), /* Fat */
  .excel-table th:nth-child(7), /* SNF */
  .excel-table th:nth-child(8), /* CLR */
  .excel-table th:nth-child(9), /* Milk Rate */
  .excel-table td:nth-child(5),
  .excel-table td:nth-child(6),
  .excel-table td:nth-child(7),
  .excel-table td:nth-child(8),
  .excel-table td:nth-child(9) {
    width: 85px;
    min-width: 85px;
  }
  
  .excel-table th:nth-child(10), /* Base SNF */
  .excel-table th:nth-child(11), /* Animal Type */
  .excel-table td:nth-child(10),
  .excel-table td:nth-child(11) {
    width: 100px;
    min-width: 100px;
  }
  
  .excel-table th:nth-child(12), /* Actions */
  .excel-table td:nth-child(12) {
    width: 60px;
    min-width: 60px;
  }
  
  /* Style for date input */
  .date-input {
    font-family: inherit;
    cursor: pointer;
  }
  
  /* Make sure the date picker icon is visible */
  .date-input::-webkit-calendar-picker-indicator {
    opacity: 1;
    cursor: pointer;
  }
  
  /* Style the serial number cell */
  .serial-number-cell {
    text-align: center;
    font-weight: 500;
    background-color: #f8f9fa;
  }
  
  /* Preview table column widths with serial number */
  .preview-table th:nth-child(1), /* Serial Number */
  .preview-table td:nth-child(1) {
    width: 40px;
    min-width: 40px;
    text-align: center;
  }
  
  .preview-table th:nth-child(2), /* Customer */
  .preview-table td:nth-child(2) {
    width: 20%;
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  /* For responsive behavior, adjust the container and table */
  .excel-container {
    width: 100%;
    overflow-x: auto;
    padding: 0;
    margin: 0;
  }
  
  @media (max-width: 1200px) {
    .excel-table {
      font-size: 12px; /* Smaller font on smaller screens */
      width: 100%;
      min-width: 1200px;
    }
    
    .csv-grid-container {
      overflow-x: auto;
      width: 100%;
    }
    
    .excel-table th, 
    .excel-table td {
      padding: 4px 6px;
      height: 32px;
    }
  }
  
  @media (max-width: 992px) {
    .cell-customer select,
    .cell-animal-type select,
    .cell-milk-type select {
      min-width: auto;
      width: 100%;
    }
  }
  
  /* Make all inputs more compact */
  .excel-table input, 
  .excel-table select {
    padding: 4px 6px;
    width: 100%;
    box-sizing: border-box;
  }
  
  /* Responsive styles */
  @media (max-width: 1400px) {
    .bulk-collection-content {
      width: 100%;
      max-width: 100%;
      padding: 0 15px;
    }
    
    .csv-grid-container {
      max-width: 100%;
      overflow-x: auto;
    }
  }
  
  @media (max-width: 1200px) {
    .preview-modal {
      max-width: 95%;
      margin: 15px;
    }
    
    .preview-table {
      min-width: 800px;
    }
  }
  
  @media (max-width: 992px) {
    .preview-modal {
      max-width: 98%;
      margin: 10px;
    }
    
    .preview-table {
      min-width: 700px;
    }
  }
  
  @media (max-width: 768px) {
    .bulk-collection-v1-container {
      padding: 10px;
    }
    
    .bulk-collection-content {
      padding: 0 5px;
    }
    
    .excel-toolbar {
      flex-direction: column;
      gap: 10px;
    }
    
    .add-row-button,
    .preview-button {
      width: 100%;
      justify-content: center;
    }
    
    .preview-modal,
    .new-customer-modal {
      width: 95%;
      max-height: 95vh;
      margin: 5px;
    }
    
    .preview-modal .modal-body,
    .new-customer-modal .modal-body {
      padding: 16px;
    }
    
    .preview-table th,
    .preview-table td {
      padding: 12px 10px;
      font-size: 13px;
    }
    
    .back-button {
      margin-right: 0;
    }
  }
  
  @media (max-width: 576px) {
    .bulk-collection-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
    
    .back-button {
      margin-right: 0;
    }
  }
  
  /* Preview modal */
  .preview-header {
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8eaed;
    width: 100%;
  }
  
  .preview-info {
    margin-bottom: 0;
    color: #5f6368;
    font-size: 14px;
    display: block;
    width: 100%;
  }
  
  .preview-table-container {
    overflow-x: auto;
    margin-bottom: 20px;
    border-radius: 4px;
    border: 1px solid #e8eaed;
    margin-top: 0;
    display: block;
    width: 100%;
    max-height: 60vh; /* Limit the height to ensure it doesn't overflow */
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  
  .preview-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    min-width: 1000px; /* Increased from 900px to accommodate the new CLR column */
  }
  
  .preview-table th,
  .preview-table td {
    padding: 14px 16px;
    border-bottom: 1px solid #e8eaed;
    white-space: nowrap;
  }
  
  /* Column width adjustments for preview table */
  .preview-table th:nth-child(1), /* Customer */
  .preview-table td:nth-child(1) {
    width: 22%;
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .preview-table th:nth-child(2), /* Date */
  .preview-table td:nth-child(2) {
    width: 11%;
  }
  
  .preview-table th:nth-child(3), /* Time */
  .preview-table td:nth-child(3) {
    width: 9%;
  }
  
  .preview-table th:nth-child(4), /* Weight */
  .preview-table th:nth-child(5), /* Fat % */
  .preview-table th:nth-child(6), /* CLR */
  .preview-table th:nth-child(7), /* SNF % */
  .preview-table td:nth-child(4),
  .preview-table td:nth-child(5),
  .preview-table td:nth-child(6),
  .preview-table td:nth-child(7) {
    width: 9%;
    text-align: right;
  }
  
  .preview-table th:nth-child(8), /* Rate */
  .preview-table th:nth-child(9), /* Amount */
  .preview-table td:nth-child(8),
  .preview-table td:nth-child(9) {
    width: 10.5%;
    text-align: right;
  }
  
  .preview-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #3c4043;
    font-size: 14px;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  
  .preview-table tbody tr:hover {
    background-color: #f8f9fa;
  }
  
  .preview-table tfoot tr {
    font-weight: 600;
  }
  
  .preview-table tfoot td {
    padding: 16px;
    border-top: 2px solid #e8eaed;
  }
  
  .total-label {
    text-align: right;
    color: #3c4043;
    font-weight: 500;
  }
  
  .total-value {
    color: #1a73e8;
    font-weight: 700;
  }
  
  /* Preview table styles */
  .preview-modal .preview-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 1100px;
  }
  
  .preview-modal .preview-table th,
  .preview-modal .preview-table td {
    padding: 8px 4px;
    border-bottom: 1px solid #e0e0e0;
    text-align: left;
  }
  
  .preview-modal .preview-table th:first-child,
  .preview-modal .preview-table td:first-child {
    width: 18%;
    max-width: 250px;
  }
  
  .preview-modal .preview-table th:nth-child(2),
  .preview-modal .preview-table td:nth-child(2) {
    width: 10%;
  }
  
  .preview-modal .preview-table th:nth-child(3),
  .preview-modal .preview-table td:nth-child(3) {
    width: 8%;
  }
  
  .preview-modal .preview-table th:nth-child(4),
  .preview-modal .preview-table td:nth-child(4),
  .preview-modal .preview-table th:nth-child(5),
  .preview-modal .preview-table td:nth-child(5),
  .preview-modal .preview-table th:nth-child(6),
  .preview-modal .preview-table td:nth-child(6),
  .preview-modal .preview-table th:nth-child(7),
  .preview-modal .preview-table td:nth-child(7),
  .preview-modal .preview-table th:nth-child(8),
  .preview-modal .preview-table td:nth-child(8),
  .preview-modal .preview-table th:nth-child(9),
  .preview-modal .preview-table td:nth-child(9) {
    width: 8%;
    text-align: right;
  }
  
  .preview-modal .preview-table th:nth-child(10),
  .preview-modal .preview-table td:nth-child(10),
  .preview-modal .preview-table th:nth-child(11),
  .preview-modal .preview-table td:nth-child(11) {
    width: 9%;
    text-align: right;
  }
  
  /* For read-only calculated fields */
  input.excel-cell-input[readonly] {
    background-color: #f8f9fa;
    color: #495057;
    cursor: default;
    border: 1px solid #e0e0e0;
  }
  
  /* Highlight calculated SNF fields */
  .calculated-cell input[readonly] {
    background-color: #e8f4ff;
    border-color: #b8daff;
    font-weight: 500;
  }
  
  /* Full-screen loading overlay */
  .submission-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    backdrop-filter: blur(4px);
  }
  
  .submission-spinner {
    border: 6px solid rgba(255, 255, 255, 0.3);
    border-top: 6px solid #007bff;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }
  
  .submission-message {
    color: white;
    font-size: 18px;
    text-align: center;
    max-width: 80%;
    margin-bottom: 15px;
    font-weight: 500;
  }
  
  .submission-progress {
    color: #fff;
    font-size: 14px;
    margin-top: 10px;
  }
  
  .global-button {
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    font-weight: 500;
    display: flex;
    align-items: center;
    transition: all 0.2s;
    cursor: pointer;
    white-space: nowrap;
  }
  
  .add-customer-button {
    background-color: #17a2b8;
    color: white;
    width: 100%;
    justify-content: center;
  }
  
  .add-customer-button:hover {
    background-color: #138496;
  }
  
  .add-customer-button svg {
    margin-right: 8px;
  }
  
  /* Delete Confirmation Modal Styles */
  .delete-confirmation-modal {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
    width: 90%;
    max-width: 420px;
    margin: auto;
    overflow: hidden;
    animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transform-origin: center;
  }
  
  @keyframes modalPop {
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  .warning-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    color: #343a40;
    display: flex;
    align-items: center;
    padding: 18px 24px;
    position: relative;
  }
  
  .warning-header h2 {
    font-size: 18px;
    margin: 0;
    font-weight: 600;
  }
  
  .warning-icon {
    font-size: 22px;
    margin-right: 12px;
    color: #e74c3c;
  }
  
  .delete-confirmation-modal .modal-body {
    padding: 28px 24px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
  }
  
  .confirmation-icon-container {
    margin-bottom: 20px;
    width: 64px;
    height: 64px;
    background-color: rgba(231, 76, 60, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .warning-text {
    color: #e74c3c;
    font-weight: 600;
    margin-bottom: 16px;
    padding: 8px 12px;
    border-radius: 4px;
    background-color: rgba(231, 76, 60, 0.08);
    font-size: 15px;
    border-left: 3px solid #e74c3c;
    width: 100%;
    max-width: 90%;
    text-align: left;
  }
  
  
  .delete-confirmation-modal .modal-body p:last-child {
    margin-bottom: 0;
    color: #495057;
    font-size: 15px;
  }
  
  .delete-confirmation-modal .modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 16px 24px 20px;
    background-color: #f8f9fa;
    border-top: 1px solid #e9ecef;
  }
  
  .delete-confirmation-modal .cancel-button {
    background-color: #f8f9fa;
    color: #495057;
    border: 1px solid #ced4da;
    padding: 10px 16px;
    border-radius: 6px;
    font-weight: 500;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s;
    margin-right: 12px;
  }
  
  .delete-confirmation-modal .cancel-button:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
  }
  
  .delete-confirmation-modal .delete-button {
    background-color: #e74c3c;
    color: white;
    border: none;
    padding: 10px 18px;
    border-radius: 6px;
    font-weight: 500;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(231, 76, 60, 0.2);
  }
  
  .delete-confirmation-modal .delete-button:hover {
    background-color: #c0392b;
    box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);
  }
  
  .delete-button svg {
    font-size: 14px;
    margin-right: 8px;
  }
  
  .cancel-button svg {
    font-size: 14px;
    margin-right: 8px;
  }
  
  .delete-confirmation-modal .close-modal-button {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #6c757d;
    transition: all 0.2s;
  }
  
  .delete-confirmation-modal .close-modal-button:hover {
    background-color: rgba(108, 117, 125, 0.1);
    color: #343a40;
  }
  
  /* Add styles for the low balance alert popup */
  .alert-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
    animation: fadeIn 0.3s ease;
  }
  
  .alert-popup {
    background-color: #fff;
    width: 90%;
    max-width: 400px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    animation: slideUp 0.3s ease;
  }
  
  .alert-popup-header {
    background-color: #f8d7da;
    color: #721c24;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f5c6cb;
  }
  
  .alert-popup-header h3 {
    margin: 0;
    font-size: 18px;
    flex-grow: 1;
  }
  
  .alert-icon {
    margin-right: 10px;
    font-size: 20px;
  }
  
  .close-alert-button {
    background: none;
    border: none;
    color: #721c24;
    cursor: pointer;
    font-size: 16px;
    padding: 0;
    margin-left: 10px;
  }
  
  .alert-popup-body {
    padding: 20px;
    color: #333;
  }
  
  .alert-balance {
    margin-top: 15px;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .low-balance-amount {
    font-weight: bold;
    color: #dc3545;
    font-size: 18px;
  }
  
  .alert-popup-footer {
    padding: 15px 20px;
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #e9ecef;
  }
  
  .close-alert-btn {
    background-color: #6c757d;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 20px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s;
  }
  
  .close-alert-btn:hover {
    background-color: #5a6268;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes slideUp {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  /* Date input wrapper styles */
  .date-input-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  
  .date-input-wrapper input[type="date"] {
    width: 100%;
    cursor: pointer;
    padding-right: 30px; /* Make room for the calendar icon */
    position: relative;
    z-index: 1; /* Ensure the input is clickable */
  }
  
  /* Style to make it more obvious the entire field is clickable */
  .date-input-wrapper::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 30px; /* Width of the clickable area on the right */
    background-color: transparent;
    cursor: pointer;
    pointer-events: none; /* Allow clicks to pass through to the input */
  }
  
  /* Delete confirmation modal styles */
  .confirmation-modal {
    background-color: white;
    border-radius: 8px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    overflow: hidden;
  }
  
  .confirmation-modal .modal-header {
    background-color: #f8f9fa;
    padding: 15px 20px;
    border-bottom: 1px solid #e9ecef;
  }
  
  .confirmation-modal .modal-header h3 {
    margin: 0;
    color: #343a40;
  }
  
  .confirmation-modal .modal-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
  }
  
  .confirmation-modal .modal-body p {
    margin-bottom: 10px;
  }
  
  .confirmation-modal .warning-text {
    color: #dc3545;
    font-weight: bold;
    margin-top: 10px;
    background-color: rgba(220, 53, 69, 0.1);
    padding: 8px 12px;
    border-radius: 4px;
    border-left: 3px solid #dc3545;
  }
  
  .confirmation-modal .modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 15px 20px;
    background-color: #f8f9fa;
    border-top: 1px solid #e9ecef;
    gap: 10px;
  }
  
  .confirmation-modal .cancel-button {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .confirmation-modal .delete-button {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .confirmation-modal .cancel-button:hover {
    background-color: #5a6268;
  }
  
  .confirmation-modal .delete-button:hover {
    background-color: #c82333;
  }
  
  /* Total row styles */
  .excel-table tfoot {
    background-color: #f0f7ff;
    border-top: 2px solid #d0e3ff;
  }
  
  .excel-table .total-row {
    font-weight: bold;
    background-color: #f0f7ff;
  }
  
  .excel-table .total-label {
    text-align: right;
    padding-right: 15px;
    font-weight: bold;
    color: #333;
  }
  
  .excel-table .total-value {
    text-align: left;
    font-weight: bold;
    font-size: 1.1em;
    color: #0056b3;
  }
  
  /* Add styles for the weight and amount totals */
  .excel-table .total-value.weight-total {
    color: #116644;
    font-size: 1.15em;
    background-color: #e3f5ee;
    border-radius: 4px;
    padding: 5px 10px;
  }
  
  .excel-table .total-value.amount-total {
    color: #662211;
    font-size: 1.15em;
    background-color: #f9e8e3;
    border-radius: 4px;
    padding: 5px 10px;
  } `, "",{"version":3,"sources":["webpack://./src/components/ProRataCollection.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,aAAa;IACb,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,iBAAiB,EAAE,sCAAsC;IACzD,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;;EAEA,uBAAuB;EACvB;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,oCAAoC;IACpC,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA,aAAa;EACb;;IAEE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,YAAY;EACd;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA,iBAAiB;EACjB;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,iBAAiB,EAAE,gCAAgC;EACrD;;EAEA,oBAAoB;EACpB;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,gDAAgD;EAClD;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;;EAEA,sBAAsB;EACtB;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,yDAA2R;IAC3R,4BAA4B;IAC5B,qCAAqC;IACrC,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc,EAAE,yBAAyB;EAC3C;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;;IAEE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,wBAAwB;EACxB;IACE,WAAW;IACX,yBAAyB;IACzB,iBAAiB,EAAE,4CAA4C;EACjE;;EAEA;;IAEE,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uCAAuC;EACzC;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,eAAe;EACjB;;EAEA,wDAAwD;EACxD;;IAEE,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;EAChC;;EAEA;;IAEE,aAAa;IACb,mCAAmC;EACrC;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,yDAA2R;IAC3R,4BAA4B;IAC5B,qCAAqC;IACrC,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;EACjB;;EAEA,6DAA6D;EAC7D;IACE,yBAAyB,EAAE,0BAA0B;IACrD,cAAc;IACd,8BAA8B;IAC9B,YAAY;EACd;;EAEA,gCAAgC;EAChC;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA,yBAAyB;EACzB;IACE,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,YAAY;EACd;;EAEA,kCAAkC;EAClC;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,WAAW;IACX,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB,EAAE,0CAA0C;IAChE,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA,8CAA8C;EAC9C;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;IAC1B,wCAAwC;IACxC,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;IACE,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA,4CAA4C;EAC5C;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA,iBAAiB;EACjB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,gBAAgB;EAClB;;EAEA;IACE,gBAAgB,EAAE,mBAAmB;IACrC,YAAY;EACd;;EAEA;IACE,iBAAiB,EAAE,yBAAyB;IAC5C,YAAY;EACd;;EAEA,4DAA4D;EAC5D;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,MAAM,EAAE,gDAAgD;EAC1D;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE;MACE,UAAU;MACV,qBAAqB;IACvB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,wCAAwC;IACxC,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;;IAEE,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA;;IAEE,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,qBAAqB;IACrB,aAAa;IACb,6CAA6C;EAC/C;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,cAAc;EAChB;;EAEA,gDAAgD;EAChD;IACE;MACE,aAAa;MACb,8BAA8B;MAC9B,SAAS;IACX;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,mBAAmB;MACnB,eAAe;IACjB;EACF;;EAEA,qCAAqC;EACrC;;IAEE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;;;;;;;;IAUE,WAAW;IACX,eAAe;EACjB;;EAEA;;;;IAIE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA,8CAA8C;EAC9C;IACE,UAAU;IACV,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA,mDAAmD;EACnD;;IAEE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,4DAA4D;EAC5D;IACE,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE;MACE,eAAe,EAAE,oCAAoC;MACrD,WAAW;MACX,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,WAAW;IACb;;IAEA;;MAEE,gBAAgB;MAChB,YAAY;IACd;EACF;;EAEA;IACE;;;MAGE,eAAe;MACf,WAAW;IACb;EACF;;EAEA,iCAAiC;EACjC;;IAEE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;;EAEA,sBAAsB;EACtB;IACE;MACE,WAAW;MACX,eAAe;MACf,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,cAAc;MACd,YAAY;IACd;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,cAAc;MACd,YAAY;IACd;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;;MAEE,WAAW;MACX,uBAAuB;IACzB;;IAEA;;MAEE,UAAU;MACV,gBAAgB;MAChB,WAAW;IACb;;IAEA;;MAEE,aAAa;IACf;;IAEA;;MAEE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA,kBAAkB;EAClB;IACE,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,cAAc;IACd,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,WAAW;IACX,gBAAgB,EAAE,mDAAmD;IACrE,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB,EAAE,2DAA2D;EAChF;;EAEA;;IAEE,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA,+CAA+C;EAC/C;;IAEE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,SAAS;EACX;;EAEA;;;;;;;;IAQE,SAAS;IACT,iBAAiB;EACnB;;EAEA;;;;IAIE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE,WAAW;IACX,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;IACV,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,SAAS;EACX;;EAEA;;;;;;;;;;;;IAYE,SAAS;IACT,iBAAiB;EACnB;;EAEA;;;;IAIE,SAAS;IACT,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,yBAAyB;EAC3B;;EAEA,oCAAoC;EACpC;IACE,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gEAAgE;IAChE,wBAAwB;EAC1B;;EAEA;IACE;MACE,UAAU;MACV,qBAAqB;IACvB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;IAChC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,8BAA8B;IAC9B,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;;EAGA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,4CAA4C;EAC9C;;EAEA;IACE,yBAAyB;IACzB,4CAA4C;EAC9C;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,0CAA0C;IAC1C,cAAc;EAChB;;EAEA,+CAA+C;EAC/C;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,SAAS;IACT,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB,EAAE,oCAAoC;IACzD,kBAAkB;IAClB,UAAU,EAAE,kCAAkC;EAChD;;EAEA,gEAAgE;EAChE;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,WAAW,EAAE,6CAA6C;IAC1D,6BAA6B;IAC7B,eAAe;IACf,oBAAoB,EAAE,8CAA8C;EACtE;;EAEA,qCAAqC;EACrC;IACE,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;IACxC,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA,gDAAgD;EAChD;IACE,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;EACnB","sourcesContent":["/* Base styling */\n.bulk-collection-v1-container {\n    padding: 20px;\n    width: 100%;\n    margin: 0 auto;\n    min-height: 100vh;\n    background-color: #f9f9f9;\n    position: relative;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .bulk-collection-content {\n    width: 100%;\n    max-width: 1400px; /* Set a max-width for large screens */\n    margin: 0 auto;\n  }\n  \n  .bulk-collection-header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 30px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #e0e0e0;\n  }\n  \n  .back-button {\n    display: flex;\n    align-items: center;\n    background: #f3f3f3;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 15px;\n    margin-right: 20px;\n    cursor: pointer;\n    transition: background 0.2s;\n    color: #333;\n    font-weight: 500;\n  }\n  \n  .back-button:hover {\n    background: #e6e6e6;\n  }\n  \n  .back-button svg {\n    margin-right: 8px;\n  }\n  \n  .bulk-collection-header h1 {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n    flex-grow: 1;\n  }\n  \n  /* Dairy Info Section */\n  .dairy-info-container {\n    width: 100%;\n    max-width: 1400px;\n    background-color: #fff;\n    border-radius: 5px;\n    padding: 15px 20px;\n    margin-bottom: 20px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n  \n  .dairy-info-content {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 20px;\n  }\n  \n  .dairy-details, .owner-details {\n    flex: 1;\n    min-width: 250px;\n  }\n  \n  .info-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n  \n  .info-icon {\n    font-size: 1.2em;\n    color: #007bff;\n    margin-right: 10px;\n    width: 20px;\n  }\n  \n  .info-label {\n    font-weight: 600;\n    color: #555;\n    margin-right: 10px;\n    min-width: 80px;\n  }\n  \n  .info-value {\n    color: #333;\n    font-weight: 500;\n  }\n  \n  .info-loading {\n    color: #6c757d;\n    text-align: center;\n    padding: 10px;\n    font-style: italic;\n  }\n  \n  /* Loading state */\n  .loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n  }\n  \n  .spinner {\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-left-color: #007bff;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n    margin-bottom: 20px;\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  /* Messages */\n  .success-message,\n  .error-message {\n    display: flex;\n    align-items: center;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n    animation: fadeIn 0.3s ease-in-out;\n  }\n  \n  .success-message {\n    background-color: #d4edda;\n    color: #155724;\n    border: 1px solid #c3e6cb;\n  }\n  \n  .error-message {\n    background-color: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n    justify-content: space-between;\n  }\n  \n  .success-message svg,\n  .error-message svg {\n    margin-right: 10px;\n    font-size: 1.2em;\n  }\n  \n  .close-error {\n    background: none;\n    border: none;\n    color: #721c24;\n    cursor: pointer;\n    padding: 5px;\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  /* Current Rate */\n  .current-rate-info {\n    background-color: #fff;\n    border-radius: 5px;\n    padding: 15px;\n    margin-bottom: 20px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 1400px; /* Match the content max-width */\n  }\n  \n  /* Global Settings */\n  .global-settings {\n    background-color: #fff;\n    border-radius: 5px;\n    padding: 15px;\n    margin-bottom: 20px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 1400px;\n  }\n  \n  .global-settings-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    align-items: center;\n  }\n  \n  .global-setting {\n    flex: 1;\n    min-width: 200px;\n  }\n  \n  .global-setting label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 500;\n    color: #343a40;\n  }\n  \n  .global-input {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n  \n  .global-input:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  }\n  \n  /* Rate display styles */\n  .rate-display {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .rate-display p {\n    margin: 0;\n    font-weight: 500;\n    color: #333;\n  }\n  \n  /* Rate Type Section */\n  .rate-type-section {\n    background-color: #fff;\n    border-radius: 5px;\n    padding: 15px;\n    margin-bottom: 20px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    width: 100%;\n    max-width: 1400px;\n  }\n  \n  .rate-type-display {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  .rate-type-display p {\n    margin: 0;\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .rate-type-edit {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .rate-type-edit label {\n    margin: 0;\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .rate-type-select {\n    padding: 8px 15px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 8px center;\n    background-size: 12px;\n    padding-right: 30px;\n  }\n  \n  .edit-rate-button {\n    display: flex;\n    align-items: center;\n    background: #f3f3f3;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 15px;\n    cursor: pointer;\n    transition: background 0.2s;\n    color: #0066cc;\n    font-weight: 500;\n  }\n  \n  .edit-rate-button:hover {\n    background: #e6e6e6;\n  }\n  \n  .edit-rate-button svg {\n    margin-right: 8px;\n  }\n  \n  /* Rate Edit Form */\n  .rate-edit {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .rate-edit label {\n    margin: 0;\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .rate-input {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin-right: 10px;\n    width: 120px;\n  }\n  \n  .save-rate-button {\n    display: flex;\n    align-items: center;\n    background: #28a745;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 15px;\n    cursor: pointer;\n    transition: background 0.2s;\n    color: white;\n    font-weight: 500;\n  }\n  \n  .save-rate-button:hover {\n    background: #218838;\n  }\n  \n  .save-rate-button svg {\n    margin-right: 8px;\n  }\n  \n  .save-rate-button:disabled {\n    background: #6c757d;\n    cursor: not-allowed;\n  }\n  \n  /* CSV/Excel Grid Layout */\n  .csv-grid-container {\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    margin-bottom: 20px;\n    width: 100%;\n    overflow-x: auto;\n    max-width: 100%;\n    margin: 0 auto; /* Center the container */\n  }\n  \n  .excel-toolbar {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px;\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #dee2e6;\n  }\n  \n  .toolbar-left {\n    display: flex;\n    gap: 8px;\n  }\n  \n  .add-row-button,\n  .preview-button {\n    padding: 8px 12px;\n    border: none;\n    border-radius: 4px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    transition: all 0.2s;\n    cursor: pointer;\n    white-space: nowrap;\n  }\n  \n  .add-row-button {\n    background-color: #28a745;\n    color: white;\n  }\n  \n  .add-row-button:hover {\n    background-color: #218838;\n  }\n  \n  .preview-button {\n    background-color: #007bff;\n    color: white;\n  }\n  \n  .preview-button:hover {\n    background-color: #0069d9;\n  }\n  \n  .add-row-button svg,\n  .preview-button svg {\n    margin-right: 8px;\n  }\n  \n  .preview-button:disabled {\n    background-color: #6c757d;\n    cursor: not-allowed;\n  }\n  \n  /* Excel Table Styling */\n  .excel-table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 1200px; /* Ensure minimum width to fit all columns */\n  }\n  \n  .excel-table th,\n  .excel-table td {\n    border: 1px solid #dee2e6;\n    padding: 0;\n    position: relative;\n    height: 34px;\n    overflow: visible;\n    font-size: 13px;\n  }\n  \n  .excel-table th {\n    background-color: #f8f9fa;\n    font-weight: 600;\n    text-align: center;\n    padding: 8px 4px;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    border-bottom: 2px solid #dee2e6;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .excel-table tbody {\n    max-height: 400px;\n    overflow-y: auto;\n  }\n  \n  .excel-table .data-row:hover {\n    background-color: #f5f9fc;\n  }\n  \n  .excel-table .data-row:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  .excel-table .data-row:nth-child(even):hover {\n    background-color: #f0f5fa;\n  }\n  \n  .excel-table td.has-error {\n    background-color: rgba(255, 0, 0, 0.05);\n  }\n  \n  .excel-cell-input,\n  .excel-cell-select {\n    width: 100%;\n    height: 100%;\n    padding: 0 6px;\n    border: none;\n    background: transparent;\n    font-size: 14px;\n  }\n  \n  /* Style for disabled inputs to make them appear faded */\n  .excel-cell-input:disabled,\n  .excel-cell-select:disabled {\n    background-color: #f5f5f5;\n    color: #9e9e9e;\n    cursor: not-allowed;\n    opacity: 0.7;\n    border-left: 2px solid #e0e0e0;\n  }\n  \n  .excel-cell-input:focus,\n  .excel-cell-select:focus {\n    outline: none;\n    box-shadow: inset 0 0 0 2px #4d90fe;\n  }\n  \n  .excel-cell-select {\n    appearance: none;\n    -webkit-appearance: none;\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 6px center;\n    background-size: 12px;\n    padding-right: 24px;\n  }\n  \n  .calculated-cell {\n    position: relative;\n  }\n  \n  .calc-indicator {\n    position: absolute;\n    top: 0;\n    right: 2px;\n    color: #0066cc;\n    font-size: 12px;\n    font-weight: bold;\n  }\n  \n  .calc-indicator.auto {\n    color: #28a745;\n    background-color: rgba(40, 167, 69, 0.1);\n    padding: 0 4px;\n    border-radius: 2px;\n    right: 4px;\n    top: 2px;\n    font-size: 10px;\n  }\n  \n  /* Special styling for calculated fields based on rate type */\n  .calculated-cell .excel-cell-input:disabled {\n    background-color: #f0f8ff; /* Light blue background */\n    color: #006699;\n    border-left: 2px solid #4dabf7;\n    opacity: 0.8;\n  }\n  \n  /* Auto-calculated field style */\n  .excel-cell-input.auto-calculated {\n    background-color: #f0f8ff;\n    font-style: italic;\n  }\n  \n  /* Disabled field container */\n  .disabled-field {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n  \n  /* Disabled input style */\n  .excel-cell-input.disabled-input {\n    background-color: #f6f6f6;\n    color: #b0b0b0;\n    text-decoration: line-through;\n    opacity: 0.6;\n  }\n  \n  /* Indicator for disabled fields */\n  .disabled-indicator {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 10px;\n    color: #999;\n    background-color: rgba(0, 0, 0, 0.05);\n    padding: 1px 4px;\n    border-radius: 2px;\n    pointer-events: none; /* Prevent it from blocking interactions */\n    white-space: nowrap;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    opacity: 0.8;\n  }\n  \n  .calc-info {\n    margin-top: -15px;\n    margin-bottom: 15px;\n    color: #0066cc;\n    font-size: 13px;\n    font-style: italic;\n  }\n  \n  .cell-error {\n    position: absolute;\n    bottom: -18px;\n    left: 0;\n    width: 100%;\n    background-color: #f8d7da;\n    color: #721c24;\n    font-size: 12px;\n    padding: 2px 4px;\n    text-align: center;\n    z-index: 20;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .cell-warning {\n    position: absolute;\n    bottom: -18px;\n    left: 0;\n    width: 100%;\n    background-color: #fff3cd;\n    color: #856404;\n    font-size: 12px;\n    padding: 2px 4px;\n    text-align: center;\n    z-index: 20;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .empty-message {\n    text-align: center;\n    padding: 20px;\n    color: #6c757d;\n    font-style: italic;\n  }\n  \n  .delete-row-btn {\n    background: none;\n    border: none;\n    color: #dc3545;\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .delete-row-btn:hover {\n    background-color: rgba(220, 53, 69, 0.1);\n  }\n  \n  /* Customer search cell and dropdown styling */\n  .customer-search-cell {\n    position: relative;\n    width: 100%;\n  }\n  \n  .excel-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    max-height: 200px;\n    overflow-y: auto;\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 0 0 4px 4px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n  }\n  \n  .dropdown-item {\n    padding: 8px 12px;\n    border-bottom: 1px solid #eee;\n    font-size: 14px;\n    transition: background-color 0.2s;\n  }\n  \n  .dropdown-item:hover {\n    background-color: #f8f9fa;\n    cursor: pointer;\n  }\n  \n  .dropdown-item.selected {\n    background-color: #e9ecef;\n    font-weight: bold;\n  }\n  \n  .dropdown-item.add-new {\n    color: #007bff;\n    font-weight: 500;\n    background-color: #f8f9fa;\n    border-top: 1px solid #ddd;\n  }\n  \n  .no-results {\n    padding: 8px 12px;\n    color: #888;\n    font-style: italic;\n    text-align: center;\n  }\n  \n  /* Make sure the dropdown appears above other elements */\n  .excel-table .data-row td {\n    position: relative;\n  }\n  \n  /* Highlight active search cell */\n  .excel-cell-input:focus {\n    outline: 2px solid #1a73e8;\n    border-color: #1a73e8;\n  }\n  \n  /* Enhance the visibility of customer cell */\n  .excel-table td:first-child .excel-cell-input {\n    width: 100%;\n    min-width: 150px;\n  }\n  \n  /* Modal Styles */\n  .modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    overflow-y: auto;\n    padding: 20px;\n    backdrop-filter: blur(3px);\n  }\n  \n  .preview-modal,\n  .new-customer-modal {\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n    width: 90%;\n    max-width: 600px;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    animation: modalFadeIn 0.3s ease-in-out;\n    overflow: hidden;\n  }\n  \n  .new-customer-modal {\n    max-width: 550px; /* Slightly wider */\n    margin: 20px;\n  }\n  \n  .preview-modal {\n    max-width: 1100px; /* Increased from 900px */\n    margin: 20px;\n  }\n  \n  /* Specific padding adjustments for the new customer modal */\n  .new-customer-modal .modal-header {\n    padding: 22px 28px;\n  }\n  \n  .new-customer-modal .modal-body {\n    padding: 28px 32px;\n  }\n  \n  .new-customer-modal .modal-footer {\n    padding: 20px 28px;\n  }\n  \n  .new-customer-modal .modal-footer button {\n    padding: 12px 20px;\n    min-width: 100px;\n  }\n  \n  /* Specific styling for the preview modal */\n  .preview-modal .modal-header {\n    padding: 22px 28px;\n  }\n  \n  .preview-modal .modal-body {\n    padding: 24px 28px;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    gap: 0; /* Remove default gap to ensure proper spacing */\n  }\n  \n  .preview-modal .modal-footer {\n    padding: 20px 28px;\n  }\n  \n  .preview-modal .modal-footer button {\n    padding: 12px 20px;\n    min-width: 100px;\n  }\n  \n  @keyframes modalFadeIn {\n    from {\n      opacity: 0;\n      transform: scale(0.9);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n  \n  .modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 18px 24px;\n    border-bottom: 1px solid #e8eaed;\n    background-color: #f8f9fa;\n  }\n  \n  .modal-header h2 {\n    margin: 0;\n    font-size: 20px;\n    color: #3c4043;\n    font-weight: 600;\n  }\n  \n  .close-modal-button {\n    background: none;\n    border: none;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #5f6368;\n    transition: all 0.2s;\n  }\n  \n  .close-modal-button:hover {\n    background-color: rgba(95, 99, 104, 0.1);\n    color: #202124;\n  }\n  \n  .modal-body {\n    padding: 24px;\n    overflow-y: auto;\n    flex-grow: 1;\n  }\n  \n  .modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    padding: 16px 24px;\n    border-top: 1px solid #e8eaed;\n    background-color: #f8f9fa;\n  }\n  \n  .modal-footer button {\n    margin-left: 12px;\n    padding: 10px 16px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    transition: all 0.2s;\n    font-size: 14px;\n  }\n  \n  .cancel-button {\n    background: #f8f9fa;\n    color: #3c4043;\n    border: 1px solid #dadce0;\n  }\n  \n  .cancel-button:hover {\n    background: #f1f3f4;\n    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);\n  }\n  \n  .confirm-button,\n  .save-button {\n    background: #1a73e8;\n    color: white;\n  }\n  \n  .confirm-button:hover,\n  .save-button:hover {\n    background: #1765cc;\n    box-shadow: 0 1px 3px rgba(26, 115, 232, 0.4);\n  }\n  \n  .confirm-button:disabled,\n  .save-button:disabled {\n    background: #c2c7c7;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n  \n  .confirm-button svg,\n  .save-button svg {\n    margin-right: 8px;\n  }\n  \n  /* New customer form */\n  .form-instructions {\n    margin-bottom: 24px;\n    color: #5f6368;\n    font-size: 14px;\n    grid-column: span 2;\n  }\n  \n  .form-group {\n    margin-bottom: 24px;\n    position: relative;\n  }\n  \n  .form-group label {\n    display: block;\n    margin-bottom: 10px;\n    font-weight: 500;\n    color: #3c4043;\n    font-size: 14px;\n  }\n  \n  .form-group input,\n  .form-group textarea {\n    width: 100%;\n    padding: 14px 16px;\n    border: 1px solid #dadce0;\n    border-radius: 4px;\n    font-size: 14px;\n    color: #202124;\n    transition: all 0.2s;\n    background-color: #fff;\n  }\n  \n  .form-group input:focus,\n  .form-group textarea:focus {\n    border-color: #1a73e8;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);\n  }\n  \n  .form-group input::placeholder,\n  .form-group textarea::placeholder {\n    color: #80868b;\n  }\n  \n  .form-group input:hover,\n  .form-group textarea:hover {\n    border-color: #bdc1c6;\n  }\n  \n  /* Required field indicator */\n  .form-group label[for=\"customer-name\"]::after {\n    content: \" *\";\n    color: #d93025;\n  }\n  \n  /* Organize form in columns for larger screens */\n  @media (min-width: 576px) {\n    .modal-body {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 20px;\n    }\n    \n    .new-customer-modal .modal-body {\n      gap: 24px;\n    }\n    \n    .form-group:last-child {\n      grid-column: span 2;\n      margin-top: 8px;\n    }\n  }\n  \n  /* Column widths in the Excel table */\n  .excel-table th:nth-child(1), /* Serial Number */\n  .excel-table td:nth-child(1) {\n    width: 50px;\n    min-width: 50px;\n    text-align: center;\n  }\n  \n  .excel-table th:nth-child(2), /* Date */\n  .excel-table td:nth-child(2) {\n    width: 120px;\n    min-width: 120px;\n  }\n  \n  .excel-table th:nth-child(3), /* Time */\n  .excel-table td:nth-child(3) {\n    width: 90px;\n    min-width: 90px;\n  }\n  \n  .excel-table th:nth-child(4), /* Customer */\n  .excel-table td:nth-child(4) {\n    width: 180px;\n    min-width: 180px;\n  }\n  \n  .excel-table th:nth-child(5), /* Weight */\n  .excel-table th:nth-child(6), /* Fat */\n  .excel-table th:nth-child(7), /* SNF */\n  .excel-table th:nth-child(8), /* CLR */\n  .excel-table th:nth-child(9), /* Milk Rate */\n  .excel-table td:nth-child(5),\n  .excel-table td:nth-child(6),\n  .excel-table td:nth-child(7),\n  .excel-table td:nth-child(8),\n  .excel-table td:nth-child(9) {\n    width: 85px;\n    min-width: 85px;\n  }\n  \n  .excel-table th:nth-child(10), /* Base SNF */\n  .excel-table th:nth-child(11), /* Animal Type */\n  .excel-table td:nth-child(10),\n  .excel-table td:nth-child(11) {\n    width: 100px;\n    min-width: 100px;\n  }\n  \n  .excel-table th:nth-child(12), /* Actions */\n  .excel-table td:nth-child(12) {\n    width: 60px;\n    min-width: 60px;\n  }\n  \n  /* Style for date input */\n  .date-input {\n    font-family: inherit;\n    cursor: pointer;\n  }\n  \n  /* Make sure the date picker icon is visible */\n  .date-input::-webkit-calendar-picker-indicator {\n    opacity: 1;\n    cursor: pointer;\n  }\n  \n  /* Style the serial number cell */\n  .serial-number-cell {\n    text-align: center;\n    font-weight: 500;\n    background-color: #f8f9fa;\n  }\n  \n  /* Preview table column widths with serial number */\n  .preview-table th:nth-child(1), /* Serial Number */\n  .preview-table td:nth-child(1) {\n    width: 40px;\n    min-width: 40px;\n    text-align: center;\n  }\n  \n  .preview-table th:nth-child(2), /* Customer */\n  .preview-table td:nth-child(2) {\n    width: 20%;\n    max-width: 280px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  /* For responsive behavior, adjust the container and table */\n  .excel-container {\n    width: 100%;\n    overflow-x: auto;\n    padding: 0;\n    margin: 0;\n  }\n  \n  @media (max-width: 1200px) {\n    .excel-table {\n      font-size: 12px; /* Smaller font on smaller screens */\n      width: 100%;\n      min-width: 1200px;\n    }\n    \n    .csv-grid-container {\n      overflow-x: auto;\n      width: 100%;\n    }\n    \n    .excel-table th, \n    .excel-table td {\n      padding: 4px 6px;\n      height: 32px;\n    }\n  }\n  \n  @media (max-width: 992px) {\n    .cell-customer select,\n    .cell-animal-type select,\n    .cell-milk-type select {\n      min-width: auto;\n      width: 100%;\n    }\n  }\n  \n  /* Make all inputs more compact */\n  .excel-table input, \n  .excel-table select {\n    padding: 4px 6px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 1400px) {\n    .bulk-collection-content {\n      width: 100%;\n      max-width: 100%;\n      padding: 0 15px;\n    }\n    \n    .csv-grid-container {\n      max-width: 100%;\n      overflow-x: auto;\n    }\n  }\n  \n  @media (max-width: 1200px) {\n    .preview-modal {\n      max-width: 95%;\n      margin: 15px;\n    }\n    \n    .preview-table {\n      min-width: 800px;\n    }\n  }\n  \n  @media (max-width: 992px) {\n    .preview-modal {\n      max-width: 98%;\n      margin: 10px;\n    }\n    \n    .preview-table {\n      min-width: 700px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .bulk-collection-v1-container {\n      padding: 10px;\n    }\n    \n    .bulk-collection-content {\n      padding: 0 5px;\n    }\n    \n    .excel-toolbar {\n      flex-direction: column;\n      gap: 10px;\n    }\n    \n    .add-row-button,\n    .preview-button {\n      width: 100%;\n      justify-content: center;\n    }\n    \n    .preview-modal,\n    .new-customer-modal {\n      width: 95%;\n      max-height: 95vh;\n      margin: 5px;\n    }\n    \n    .preview-modal .modal-body,\n    .new-customer-modal .modal-body {\n      padding: 16px;\n    }\n    \n    .preview-table th,\n    .preview-table td {\n      padding: 12px 10px;\n      font-size: 13px;\n    }\n    \n    .back-button {\n      margin-right: 0;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .bulk-collection-header {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 10px;\n    }\n    \n    .back-button {\n      margin-right: 0;\n    }\n  }\n  \n  /* Preview modal */\n  .preview-header {\n    margin-bottom: 24px;\n    padding-bottom: 16px;\n    border-bottom: 1px solid #e8eaed;\n    width: 100%;\n  }\n  \n  .preview-info {\n    margin-bottom: 0;\n    color: #5f6368;\n    font-size: 14px;\n    display: block;\n    width: 100%;\n  }\n  \n  .preview-table-container {\n    overflow-x: auto;\n    margin-bottom: 20px;\n    border-radius: 4px;\n    border: 1px solid #e8eaed;\n    margin-top: 0;\n    display: block;\n    width: 100%;\n    max-height: 60vh; /* Limit the height to ensure it doesn't overflow */\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  }\n  \n  .preview-table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: left;\n    min-width: 1000px; /* Increased from 900px to accommodate the new CLR column */\n  }\n  \n  .preview-table th,\n  .preview-table td {\n    padding: 14px 16px;\n    border-bottom: 1px solid #e8eaed;\n    white-space: nowrap;\n  }\n  \n  /* Column width adjustments for preview table */\n  .preview-table th:nth-child(1), /* Customer */\n  .preview-table td:nth-child(1) {\n    width: 22%;\n    max-width: 280px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .preview-table th:nth-child(2), /* Date */\n  .preview-table td:nth-child(2) {\n    width: 11%;\n  }\n  \n  .preview-table th:nth-child(3), /* Time */\n  .preview-table td:nth-child(3) {\n    width: 9%;\n  }\n  \n  .preview-table th:nth-child(4), /* Weight */\n  .preview-table th:nth-child(5), /* Fat % */\n  .preview-table th:nth-child(6), /* CLR */\n  .preview-table th:nth-child(7), /* SNF % */\n  .preview-table td:nth-child(4),\n  .preview-table td:nth-child(5),\n  .preview-table td:nth-child(6),\n  .preview-table td:nth-child(7) {\n    width: 9%;\n    text-align: right;\n  }\n  \n  .preview-table th:nth-child(8), /* Rate */\n  .preview-table th:nth-child(9), /* Amount */\n  .preview-table td:nth-child(8),\n  .preview-table td:nth-child(9) {\n    width: 10.5%;\n    text-align: right;\n  }\n  \n  .preview-table th {\n    background-color: #f8f9fa;\n    font-weight: 600;\n    color: #3c4043;\n    font-size: 14px;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n  \n  .preview-table tbody tr:hover {\n    background-color: #f8f9fa;\n  }\n  \n  .preview-table tfoot tr {\n    font-weight: 600;\n  }\n  \n  .preview-table tfoot td {\n    padding: 16px;\n    border-top: 2px solid #e8eaed;\n  }\n  \n  .total-label {\n    text-align: right;\n    color: #3c4043;\n    font-weight: 500;\n  }\n  \n  .total-value {\n    color: #1a73e8;\n    font-weight: 700;\n  }\n  \n  /* Preview table styles */\n  .preview-modal .preview-table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 1100px;\n  }\n  \n  .preview-modal .preview-table th,\n  .preview-modal .preview-table td {\n    padding: 8px 4px;\n    border-bottom: 1px solid #e0e0e0;\n    text-align: left;\n  }\n  \n  .preview-modal .preview-table th:first-child,\n  .preview-modal .preview-table td:first-child {\n    width: 18%;\n    max-width: 250px;\n  }\n  \n  .preview-modal .preview-table th:nth-child(2),\n  .preview-modal .preview-table td:nth-child(2) {\n    width: 10%;\n  }\n  \n  .preview-modal .preview-table th:nth-child(3),\n  .preview-modal .preview-table td:nth-child(3) {\n    width: 8%;\n  }\n  \n  .preview-modal .preview-table th:nth-child(4),\n  .preview-modal .preview-table td:nth-child(4),\n  .preview-modal .preview-table th:nth-child(5),\n  .preview-modal .preview-table td:nth-child(5),\n  .preview-modal .preview-table th:nth-child(6),\n  .preview-modal .preview-table td:nth-child(6),\n  .preview-modal .preview-table th:nth-child(7),\n  .preview-modal .preview-table td:nth-child(7),\n  .preview-modal .preview-table th:nth-child(8),\n  .preview-modal .preview-table td:nth-child(8),\n  .preview-modal .preview-table th:nth-child(9),\n  .preview-modal .preview-table td:nth-child(9) {\n    width: 8%;\n    text-align: right;\n  }\n  \n  .preview-modal .preview-table th:nth-child(10),\n  .preview-modal .preview-table td:nth-child(10),\n  .preview-modal .preview-table th:nth-child(11),\n  .preview-modal .preview-table td:nth-child(11) {\n    width: 9%;\n    text-align: right;\n  }\n  \n  /* For read-only calculated fields */\n  input.excel-cell-input[readonly] {\n    background-color: #f8f9fa;\n    color: #495057;\n    cursor: default;\n    border: 1px solid #e0e0e0;\n  }\n  \n  /* Highlight calculated SNF fields */\n  .calculated-cell input[readonly] {\n    background-color: #e8f4ff;\n    border-color: #b8daff;\n    font-weight: 500;\n  }\n  \n  /* Full-screen loading overlay */\n  .submission-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n    backdrop-filter: blur(4px);\n  }\n  \n  .submission-spinner {\n    border: 6px solid rgba(255, 255, 255, 0.3);\n    border-top: 6px solid #007bff;\n    border-radius: 50%;\n    width: 60px;\n    height: 60px;\n    animation: spin 1s linear infinite;\n    margin-bottom: 20px;\n  }\n  \n  .submission-message {\n    color: white;\n    font-size: 18px;\n    text-align: center;\n    max-width: 80%;\n    margin-bottom: 15px;\n    font-weight: 500;\n  }\n  \n  .submission-progress {\n    color: #fff;\n    font-size: 14px;\n    margin-top: 10px;\n  }\n  \n  .global-button {\n    padding: 8px 12px;\n    border: none;\n    border-radius: 4px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    transition: all 0.2s;\n    cursor: pointer;\n    white-space: nowrap;\n  }\n  \n  .add-customer-button {\n    background-color: #17a2b8;\n    color: white;\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .add-customer-button:hover {\n    background-color: #138496;\n  }\n  \n  .add-customer-button svg {\n    margin-right: 8px;\n  }\n  \n  /* Delete Confirmation Modal Styles */\n  .delete-confirmation-modal {\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n    width: 90%;\n    max-width: 420px;\n    margin: auto;\n    overflow: hidden;\n    animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    transform-origin: center;\n  }\n  \n  @keyframes modalPop {\n    0% {\n      opacity: 0;\n      transform: scale(0.8);\n    }\n    100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n  \n  .warning-header {\n    background-color: #f8f9fa;\n    border-bottom: 1px solid #e9ecef;\n    color: #343a40;\n    display: flex;\n    align-items: center;\n    padding: 18px 24px;\n    position: relative;\n  }\n  \n  .warning-header h2 {\n    font-size: 18px;\n    margin: 0;\n    font-weight: 600;\n  }\n  \n  .warning-icon {\n    font-size: 22px;\n    margin-right: 12px;\n    color: #e74c3c;\n  }\n  \n  .delete-confirmation-modal .modal-body {\n    padding: 28px 24px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: white;\n  }\n  \n  .confirmation-icon-container {\n    margin-bottom: 20px;\n    width: 64px;\n    height: 64px;\n    background-color: rgba(231, 76, 60, 0.1);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .warning-text {\n    color: #e74c3c;\n    font-weight: 600;\n    margin-bottom: 16px;\n    padding: 8px 12px;\n    border-radius: 4px;\n    background-color: rgba(231, 76, 60, 0.08);\n    font-size: 15px;\n    border-left: 3px solid #e74c3c;\n    width: 100%;\n    max-width: 90%;\n    text-align: left;\n  }\n  \n  \n  .delete-confirmation-modal .modal-body p:last-child {\n    margin-bottom: 0;\n    color: #495057;\n    font-size: 15px;\n  }\n  \n  .delete-confirmation-modal .modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    padding: 16px 24px 20px;\n    background-color: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n  }\n  \n  .delete-confirmation-modal .cancel-button {\n    background-color: #f8f9fa;\n    color: #495057;\n    border: 1px solid #ced4da;\n    padding: 10px 16px;\n    border-radius: 6px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.2s;\n    margin-right: 12px;\n  }\n  \n  .delete-confirmation-modal .cancel-button:hover {\n    background-color: #e9ecef;\n    border-color: #adb5bd;\n  }\n  \n  .delete-confirmation-modal .delete-button {\n    background-color: #e74c3c;\n    color: white;\n    border: none;\n    padding: 10px 18px;\n    border-radius: 6px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 4px rgba(231, 76, 60, 0.2);\n  }\n  \n  .delete-confirmation-modal .delete-button:hover {\n    background-color: #c0392b;\n    box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);\n  }\n  \n  .delete-button svg {\n    font-size: 14px;\n    margin-right: 8px;\n  }\n  \n  .cancel-button svg {\n    font-size: 14px;\n    margin-right: 8px;\n  }\n  \n  .delete-confirmation-modal .close-modal-button {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: transparent;\n    border: none;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: #6c757d;\n    transition: all 0.2s;\n  }\n  \n  .delete-confirmation-modal .close-modal-button:hover {\n    background-color: rgba(108, 117, 125, 0.1);\n    color: #343a40;\n  }\n  \n  /* Add styles for the low balance alert popup */\n  .alert-popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n    animation: fadeIn 0.3s ease;\n  }\n  \n  .alert-popup {\n    background-color: #fff;\n    width: 90%;\n    max-width: 400px;\n    border-radius: 8px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n    animation: slideUp 0.3s ease;\n  }\n  \n  .alert-popup-header {\n    background-color: #f8d7da;\n    color: #721c24;\n    padding: 15px 20px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #f5c6cb;\n  }\n  \n  .alert-popup-header h3 {\n    margin: 0;\n    font-size: 18px;\n    flex-grow: 1;\n  }\n  \n  .alert-icon {\n    margin-right: 10px;\n    font-size: 20px;\n  }\n  \n  .close-alert-button {\n    background: none;\n    border: none;\n    color: #721c24;\n    cursor: pointer;\n    font-size: 16px;\n    padding: 0;\n    margin-left: 10px;\n  }\n  \n  .alert-popup-body {\n    padding: 20px;\n    color: #333;\n  }\n  \n  .alert-balance {\n    margin-top: 15px;\n    padding: 10px;\n    background-color: #f8f9fa;\n    border-radius: 4px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .low-balance-amount {\n    font-weight: bold;\n    color: #dc3545;\n    font-size: 18px;\n  }\n  \n  .alert-popup-footer {\n    padding: 15px 20px;\n    display: flex;\n    justify-content: flex-end;\n    border-top: 1px solid #e9ecef;\n  }\n  \n  .close-alert-btn {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.2s;\n  }\n  \n  .close-alert-btn:hover {\n    background-color: #5a6268;\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n  \n  @keyframes slideUp {\n    from {\n      transform: translateY(50px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n  \n  /* Date input wrapper styles */\n  .date-input-wrapper {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n  \n  .date-input-wrapper input[type=\"date\"] {\n    width: 100%;\n    cursor: pointer;\n    padding-right: 30px; /* Make room for the calendar icon */\n    position: relative;\n    z-index: 1; /* Ensure the input is clickable */\n  }\n  \n  /* Style to make it more obvious the entire field is clickable */\n  .date-input-wrapper::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 30px; /* Width of the clickable area on the right */\n    background-color: transparent;\n    cursor: pointer;\n    pointer-events: none; /* Allow clicks to pass through to the input */\n  }\n  \n  /* Delete confirmation modal styles */\n  .confirmation-modal {\n    background-color: white;\n    border-radius: 8px;\n    width: 400px;\n    max-width: 90%;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    overflow: hidden;\n  }\n  \n  .confirmation-modal .modal-header {\n    background-color: #f8f9fa;\n    padding: 15px 20px;\n    border-bottom: 1px solid #e9ecef;\n  }\n  \n  .confirmation-modal .modal-header h3 {\n    margin: 0;\n    color: #343a40;\n  }\n  \n  .confirmation-modal .modal-body {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .confirmation-modal .modal-body p {\n    margin-bottom: 10px;\n  }\n  \n  .confirmation-modal .warning-text {\n    color: #dc3545;\n    font-weight: bold;\n    margin-top: 10px;\n    background-color: rgba(220, 53, 69, 0.1);\n    padding: 8px 12px;\n    border-radius: 4px;\n    border-left: 3px solid #dc3545;\n  }\n  \n  .confirmation-modal .modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    padding: 15px 20px;\n    background-color: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    gap: 10px;\n  }\n  \n  .confirmation-modal .cancel-button {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .confirmation-modal .delete-button {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .confirmation-modal .cancel-button:hover {\n    background-color: #5a6268;\n  }\n  \n  .confirmation-modal .delete-button:hover {\n    background-color: #c82333;\n  }\n  \n  /* Total row styles */\n  .excel-table tfoot {\n    background-color: #f0f7ff;\n    border-top: 2px solid #d0e3ff;\n  }\n  \n  .excel-table .total-row {\n    font-weight: bold;\n    background-color: #f0f7ff;\n  }\n  \n  .excel-table .total-label {\n    text-align: right;\n    padding-right: 15px;\n    font-weight: bold;\n    color: #333;\n  }\n  \n  .excel-table .total-value {\n    text-align: left;\n    font-weight: bold;\n    font-size: 1.1em;\n    color: #0056b3;\n  }\n  \n  /* Add styles for the weight and amount totals */\n  .excel-table .total-value.weight-total {\n    color: #116644;\n    font-size: 1.15em;\n    background-color: #e3f5ee;\n    border-radius: 4px;\n    padding: 5px 10px;\n  }\n  \n  .excel-table .total-value.amount-total {\n    color: #662211;\n    font-size: 1.15em;\n    background-color: #f9e8e3;\n    border-radius: 4px;\n    padding: 5px 10px;\n  } "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
